export class NodeSort {
    static nodeSortOnAttributes(attributeA: string, attributeB: string): number {
        let nameA = isNaN(+attributeA) || isNaN(+attributeB) ? attributeA : Number.parseInt(attributeA);
        let nameB = isNaN(+attributeA) || isNaN(+attributeB) ? attributeB : Number.parseInt(attributeB);

        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }
        return 0;
    }
    static nodeSortOnUnsavedIndex(localNodeAIdx: number, localNodeBIdx: number): number {
        if (localNodeAIdx < localNodeBIdx) {
            return -1;
        }
        if (localNodeAIdx > localNodeBIdx) {
            return 1;
        }
        return 0;
    }
}
